import React, { useState, useEffect, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import './../styles/dashboard.css';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AiOutlineLineChart } from 'react-icons/ai';
import Switch from '@mui/material/Switch'; 
import axios from 'axios';
import styled from 'styled-components';
import Table from '../components/partials/Table';

const Styles = styled.div`
  padding: 1rem;

  table {
    border-collapse: separate;
    border: 1px solid #66bfbf;
    border-radius: 5px;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;
      :last-child {
        border-right: 0;
      }
    }

    tbody tr:nth-child(odd) {
      background: rgba(102, 191, 191, 0.25);
    }
  }
`;

function Dashboard(state) {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(true);

  const isLoggedIn = state.isLoggedIn;

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/')
    } else {

  

      if (loadingData) {
        // if the result is not ready so you make the axios call
        getRepostCount();
      }
    }
  }, []);

  const getRepostCount = () => {
    axios
      .get('https://emaildrop.com/md/repostCounts', {})
      .then(response => {
        setData(response.data);
        setLoadingData(false);
      })
      .catch(error => console.log('api errors:', error));
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Aggregator',
        accessor: 'name',
      },
      {
        Header: 'Active',
        accessor: 'is_active',
        
        Cell: ({ row }) => (
          <Switch 
            checked={row.original.is_active == 1 ? true : false} 
            onChange={() => handleToggleActive(row)}
          />
        )
      },
      {
        Header: 'Today',
        accessor: 'today',
      },
      {
        Header: 'Yesterday',
        accessor: 'yesterday',
      },
      {
        Header: 'This Week',
        accessor: 'week',
      },
      {
        Header: 'This Month',
        accessor: 'mtd',
      },
      {
        Header: 'Last Month',
        accessor: 'lastMonth',
      },
    ],
    [data]
  );

  const handleToggleActive = row => {
    const newData = [...data];
    newData[row.index].is_active = newData[row.index].is_active == 1 ? 0 : 1;
    updateAggregator(newData[row.index], "is_active")
    setData(newData);
  }

  const updateAggregator = (aggregator, field) => {
    console.log(aggregator)

    const data = {
      "field": field,
      "data": aggregator
    }

    axios.post('https://emaildrop.com/md/toggleAggregator', { data })
    .then(response => {
    })
    .catch(error => console.log('api errors:', error));
  }

  return (
    <Container className="dashboard">
      <h1>
        <AiOutlineLineChart /> Sold Reports
      </h1>
      {loadingData ? (
        <p>Loading Please wait...</p>
      ) : (
        <Styles>
          <Table className="repostTable" columns={columns} data={data} />
        </Styles>
      )}
    </Container>
  );
}

const mapStateToProps = function (state) {
  return {
    user: state.userReducer.user,
    isLoggedIn: state.userReducer.isLoggedIn,
  };
};

export default connect(mapStateToProps)(Dashboard);
